import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AuthHttpIntercepter } from 'app/core/handlers/AuthHttpIntercepter';


import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS} from '@angular/common/http';


import { CoreModule } from '../core/core.module';

import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';

import { NotificationsComponent } from '../core/notifications/notifications.component';


// 3rd Party
import { MessagesModule, GrowlModule } from 'primeng/primeng';
import { AgmCoreModule } from '@agm/core';
import { NavBarComponent } from './nav-bar/nav-bar.component';

import { BsDropdownModule } from 'ngx-bootstrap';
import { SwiperModule } from 'angular2-useful-swiper';
import { CategoryHeaderComponent } from './category-header/category-header.component';
import { SideNavBarComponent } from './side-nav-bar/side-nav-bar.component';

import { ModalModule } from 'ngx-modal';
import { CustomRequestOptions } from 'app/core/extensions/custom-request-options';
import {ArchwizardModule} from 'ng2-archwizard';
// import { RequestOptions } from '@angular/http';





@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    CoreModule,
    MessagesModule,
    GrowlModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDHjHGA-Gf9hMRWKZsNL_-pQBiJ_ykd0CY',
      libraries: ['places']
    }),
    BsDropdownModule,
    SwiperModule,
    ModalModule,
    ArchwizardModule
  ],
  declarations: [
    HeaderComponent,
    FooterComponent,
    NotificationsComponent,
    NavBarComponent,
    CategoryHeaderComponent,
    SideNavBarComponent
  ],
  providers: [
    { 
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpIntercepter,
      multi: true
    }
    // { provide: RequestOptions, useClass: CustomRequestOptions },
  ],
  exports: [
    CommonModule,
    RouterModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    CoreModule,
    HeaderComponent,
    FooterComponent,
    NavBarComponent,
    SideNavBarComponent,
    MessagesModule,
    GrowlModule,
    NotificationsComponent,
    CategoryHeaderComponent,
    ArchwizardModule
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts